import { WarehouseAddressCollectionDataProvider } from '@steelbuy/data-provider';
import { CheckoutAddAddress } from '../../../components/checkout/CheckoutAddAddress';

export const MyAlertsCheckoutAddAddressView = () => (
    <WarehouseAddressCollectionDataProvider>
        <CheckoutAddAddress />
    </WarehouseAddressCollectionDataProvider>
);
